//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'
// const moment = require('moment')
export default {
  name: 'HelloWorld',
  data: () => {
    return {
      numero: {
        msg: "Boa tarde. Me chamo Neimar e fiquei feliz em ver seu interesse em nossa vaga de trabalho da DouraSoft. Você já inscreveu seu currículo no site https://jobs.solides.com/vagas/73566 ?",
        telefone: "",
        enviadoem: ""
      }
    }
  },
  methods: {
    enviar () {
      //eslint-disable-next-line
      window.open('https://api.whatsapp.com/send?phone=' + this.numero.telefone + '&text=' + this.numero.msg.replace(/\ /g, '%20'), '_blank')
      // this.saveLog(this.numero)
      this.numero.telefone = ""
      // this.numero.msg = "Boa tarde. Me chamo Neimar e fiquei feliz em ver seu interesse em nossa vaga de trabalho da DouraSoft. Você já inscreveu seu currículo no site https://jobs.solides.com/vagas/73566 ?"
    },
    // saveLog (num) {
    //   num.enviadoem = moment().format('DD/MM/YYYY HH:mm:ss')
    //   axios.post('http://localhost:3000/enviados', num)
    //     .then(() => {
    //     })
    // },
    preenche (type) {
      if (type === 1) {
        this.numero.telefone = "+5567" + this.numero.telefone
      }
      if (type === 2) {
        this.numero.telefone = "+55" + this.numero.telefone
      }
      this.enviar()
    }
  }
}
